// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"4f7b2f68","473":"e339a956","522":"b6b409bf","712":"287ffc79","752":"98e26861","963":"5066558c"}[chunkId] + ".chunk.js";
};